<template>
  <div class="container">
    <w-input
      v-model="queryText"
      placeholder="请输入明细按下Enter键查询"
      suffix-icon="w-icon-search"
      @keyup.enter.native="searchText"
    ></w-input>
    <w-table
      ref="zskTable"
      :data="tableData"
      style="width: 100%"
      :height="'calc(100% - 120px)'"
      class="mt-20"
      @selection-change="handleSelectionChange"
    >
      <w-table-column type="selection" width="50"></w-table-column>
      <w-table-column
        v-for="item in columns"
        :key="item.prop"
        :prop="item.prop"
        :label="item.label"
        :width="item.width"
      ></w-table-column>
    </w-table>
    <w-row>
      <w-pagination
        :total="total"
        :page-sizes="pageArr"
        :page-size="pageSize"
        @current-change="pageChange"
        @page-size-change="handlePageSizeChange"
      ></w-pagination>
    </w-row>
    <w-row class="mt-10" style="text-align: right">
      <w-button size="mini" @click="cancel">取消</w-button>
      <w-button size="mini" type="primary" @click="ensure">确认</w-button>
    </w-row>
  </div>
</template>

<script>
export default {
  name: 'Zsk',
  props: {
    zskLx: {
      type: String,
      default: () => ''
    },
    bddms: {
      type: String,
      default: () => ''
    },
    zzjgdms: {
      type: String,
      default: () => ''
    }
  },
  data() {
    return {
      queryText: '',
      pageArr: [5, 10, 20],
      tableData: [],
      page: 1,
      pageSize: 5,
      total: 0,
      columns: [
        { prop: 'MEMO', label: '明细' },
        { prop: 'BZ', label: '说明' }
      ],
      zskLxList: [
        { id: 1080, name: '存在问题' },
        { id: 1081, name: '备用字段1' },
        { id: 1082, name: '备用字段2' },
        { id: 1083, name: '原因分析' },
        { id: 1084, name: '整改措施' },
        { id: 1116, name: '评价内容' }
      ],
      selectData: []
    }
  },
  created() {
    this.getData()
  },
  methods: {
    searchText() {
      this.page = 1
      this.getData()
    },
    getData() {
      this.$requestApi('GetZSKList', {
        zskLx: this.zskLx,
        PageIndex: this.page,
        bddms: this.bddms,
        PageSize: this.pageSize,
        queryText: this.queryText,
        zzjgdms: this.zzjgdms
      }).then((res) => {
        this.tableData = res.data
        this.total = res.total
      })
    },
    handleSelectionChange(val) {
      this.selectData = val
    },
    cancel() {
      this.$emit('close')
    },
    ensure() {
      this.$emit('close', this.selectData)
    },
    pageChange(val) {
      this.page = val
      this.getData()
    },
    handlePageSizeChange(val) {
      this.page = 1
      this.getData()
    }
  }
}
</script>

<style scoped lang="scss">
.container {
  padding: 20px;
  width: 100%;
  height: 100%;
}
/deep/ .w-pagination {
  margin-top: 10px;
}
</style>
